<template>
<div>
    <nav class="py-2 bg-light border-bottom">
        <div class="flex-wrap">
            <div class="header-submain">
                <ul class="nav nav-underline">
                    <li class="nav-item">
                        <img class="logo" src="https://edcentra-lms.b-cdn.net/assets/Logo/Image/b5987e8c-98f9-4c3a-be25-02a6b861c110285647_globe_icon.png" alt="">
                    </li>
                    <li class="nav-item">
                        <a class="list nav-link" :class="{ 'active': isRouteActive('/Students'), 'disabled': isRouteActive('/Students') }" @click="redirectToStudentList">Student List</a>
                    </li>
                    <li class="nav-item">
                        <a class="list nav-link" :class="{ 'active': isRouteActive('/Invoices'), 'disabled': isRouteActive('/Invoices') }" @click="redirectToInvoiceList">Invoices</a>
                    </li>
                    <li class="nav-item">
                        <a class="list nav-link" :class="{ 'active': isRouteActive('/Payments'), 'disabled': isRouteActive('/Payments') }" @click="redirectToPaymentList">Payments</a>
                    </li>
                </ul>

                <ul class="nav">
                    <button class="btn mr-3" @click="Logout">
                        <i class="fa-solid fa-right-from-bracket" style="color: #ff0000;"></i>
                    </button>
                </ul>
            </div>
        </div>
    </nav>
</div>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    name: 'Logout',
    data() {
        return {

        };
    },
    methods: {
        ...mapActions(['getStudentList']),
        Logout() {
            localStorage.clear();
            this.$router.push('/login');
        },
        redirectToStudentList() {
            if (!this.isRouteActive('/Students')) {
                this.$router.push('/Students');
            }
        },
        redirectToInvoiceList() {
            if (!this.isRouteActive('/Invoices')) {
                this.$router.push('/Invoices');
            }
        },
        redirectToPaymentList() {
            if (!this.isRouteActive('/Payments')) {
                this.$router.push('/Payments');
            }
        },
        isRouteActive(route) {
            return this.$route.path === route;
        },
    },
}
</script>

<style scoped>
.logo {
    max-height: 3rem;
    margin-right: 2rem;
}

.header-submain {
    display: flex;
    justify-content: space-between;
}

.active {
    font-weight: bold;
    color: #007bff;
}

.list {
    color: black;
    font-weight: bold;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}
</style>
